import React from "react";
import GuitarTuner from "./guitar-tuner/app";
import VoiceChord from "./voice-chord";
import Metronome from "./metronome";
import BoxMetronome from "./box-metronome";
import GuitarScale from "./guitar-scale";
import VoicePitch from "./voice-pitch";
import Whiteboard from "./white-board";
import Piano from "./piano";
import Sample1 from "./sample1";
import Sample2 from "./sample2";
import Sample3 from "./sample3";
import Audio1 from "./audio-white-board-1";
import Audio2 from "./audio-whiteboard-2";
import Audio3 from "./audio-white-board-3";
import AnnotationTool from "./annotation";
import WhiteboardWaltzMinor from './Whiteboard-Waltz-in-A-Minor';
import Drum from './drum';
import DrumSet from "./drum-set";
// get the active tool
const Tools = (props) => {
    const { activeTool, iAmRecorder } = props;
    if (iAmRecorder) return null;

    switch (activeTool) {
        case "guitar-tuner":
            return <GuitarTuner {...props} />;
        case "voice-chord":
            return <VoiceChord {...props} />;
        case "metronome":
            return <Metronome {...props} />;
        case "box-metronome":
            return <BoxMetronome {...props} />;
        case "guitar-scale":
            return <GuitarScale {...props} />;
        case "voice-pitch":
            return <VoicePitch {...props} />;
        case "white-board":
            return <Whiteboard {...props} />;
        case 'piano':
            return <Piano {...props} />;
        case "sample1":
            return <Sample1 {...props} />;
        case "sample2":
            return <Sample2 {...props} />;
        case "sample3":
            return <Sample3 {...props} />;
        case "audio1":
            return <Audio1 {...props} />;
        case "audio2":
            return <Audio2 {...props} />;
        case "audio3":
            return <Audio3 {...props} />;
        case "whiteboard_waltz_minor":
            return <WhiteboardWaltzMinor {...props} />;
        case "drum":
            return <Drum {...props} />;
        case "drum-set":
            return <DrumSet {...props} />;
        // case "annotation":
        //     return <AnnotationTool {...props} />;
        default:
            return null;
    }
};

export default Tools;
